/**
 * Profiles SoT typography / density for Feedback section cards.
 * Prefer these over ad-hoc text sizes on G1+ surfaces.
 */

export const FEEDBACK_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight text-foreground';

export const FEEDBACK_SECTION_BODY_CLASS =
  'text-[13.5px] leading-relaxed text-foreground';

export const FEEDBACK_SECTION_MUTED_CLASS =
  'text-[13.5px] leading-relaxed text-muted-foreground';

export const FEEDBACK_SECTION_LABEL_CLASS =
  'text-[11px] font-semibold uppercase tracking-[0.6px] text-muted-foreground';

/** Card section density — Profiles SoT (p-5 / sm:p-6). */
export const FEEDBACK_SECTION_CARD_CLASS = 'gap-0 py-0';

export const FEEDBACK_SECTION_CARD_HEADER_CLASS = 'px-5 pt-5 sm:px-6 sm:pt-6';

export const FEEDBACK_SECTION_CARD_CONTENT_CLASS = 'px-5 pb-5 sm:px-6 sm:pb-6';

/** Ghost-accent selected / highlight chrome (brand blue, not KPI wash). */
export const FEEDBACK_GHOST_SELECTED_CLASS =
  'border-[color:var(--ghost-accent-border)] bg-[color:var(--ghost-accent-bg)] text-[color:var(--ghost-accent-fg)]';

export const FEEDBACK_GHOST_DASHED_PANEL_CLASS =
  'rounded-[var(--r-control)] border border-dashed border-[color:var(--ghost-accent-border)] bg-[color:var(--ghost-accent-bg)]';

/** List row container — whisper Card radius, no flat graphite slab. */
export const FEEDBACK_LIST_SURFACE_CLASS =
  'divide-y divide-border overflow-hidden rounded-[var(--r-card)] border border-border/60 bg-card shadow-[var(--shadow-card)]';
